import { type FC, useEffect } from "react";
import { useAudienceContext } from "../providers/AudienceContext";
import type { AudienceComposerProps } from "../types";

const AudienceComposer: FC<AudienceComposerProps> = ({ tabs }) => {
	const { registerTabs } = useAudienceContext();

	// Register tabs whenever they change
	useEffect(() => {
		if (tabs.length > 0) {
			registerTabs(tabs);
		}
	}, [tabs, registerTabs]);

	// AudienceComposer doesn't render anything visible itself
	// It just registers the provided tabs
	return null;
};

AudienceComposer.displayName = "AudienceComposer";

export default AudienceComposer;
